import React from 'react';
import { Form } from 'react-bootstrap';
import styles from '../hcpRequestDraft.module.css';

/**
 * Highlight "prefilled" only when editable and matches creation snapshot baseline.
 *
 * @param {'editable' | 'readOnly'} mode
 * @param {{
 *   label: string,
 *   htmlId: string,
 *   value: string,
 *   type?: string,
 *   mode: 'editable' | 'readOnly',
 *   highlightPrefilled: boolean,
 *   readOnlyReason?: string,
 *   onChange?: (next: string) => void,
 * }} props
 */
export default function PrefilledFieldShell({
  label,
  htmlId,
  value,
  type = 'text',
  mode,
  highlightPrefilled,
  readOnlyReason,
  onChange,
}) {
  const editable = mode === 'editable';
  const v = value ?? '';

  let controlClass;
  if (!editable) {
    controlClass = styles.readOnlyStatic;
  } else if (highlightPrefilled) {
    controlClass = styles.prefilled;
  } else {
    controlClass = styles.userEdited;
  }

  return (
    <Form.Group className="mb-3">
      <Form.Label className="fw-semibold mb-1" htmlFor={htmlId}>
        {label}
        {!editable && readOnlyReason ? (
          <span className="text-muted fw-normal ms-1 small">
            ({readOnlyReason})
          </span>
        ) : null}
      </Form.Label>
      {editable ? (
        <Form.Control
          id={htmlId}
          type={type}
          value={v}
          onChange={(e) => onChange?.(e.target.value)}
          className={controlClass}
          autoComplete="off"
        />
      ) : (
        <Form.Control
          plaintext
          readOnly
          id={htmlId}
          value={v}
          className={`mb-0 ${controlClass}`}
        />
      )}
    </Form.Group>
  );
}
